import React from "react";
import ReactDOM from "react-dom";

import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"
import App from '../src/components/App.jsx'

// frontpage pagination.
// toggle between the different frontpage images.
const isMobile = window.matchMedia('(max-width: 900px)');
const frontpageVideo = document.getElementById('frontpage-video');
// Hide video on mobile
if (isMobile.matches) {
	if (frontpageVideo) {
		frontpageVideo.style.display = "none";
		frontpageVideo.children[0].src = '';
	}
}

if (document.body.classList.contains("home") && (isMobile.matches || !frontpageVideo)) {
    const slider = tns({
        container: '.slider',
        mode: 'gallery',
        items: 1,
        autoplay: true,
        center: true,
        controls: true,
        nav: true,
        autoplayButtonOutput: false,
        rewind: true,
        touch: false,
        animateIn: 'tns-fadeIn',
        animateOut: 'tns-fadeOut',
    });

    // slider is paused when nav is clicked. Restarts loop
    const onChange = function () {
        slider.play();
    }
    slider.events.on('transitionEnd', onChange);
}

// Sets main menu to display none.
const showMenu = (bool) => {
    const menu = document.getElementById('site-menu');
    menu.classList.remove('active');
    document.body.classList.remove('noscroll');

    if(bool) {
        menu.classList.add('active');
        document.body.classList.add('noscroll');
    }
}

// add eventlistener to main menu button.
const menuToggle = document.getElementById('menu-toggle');
const logo = document.getElementById('logo');
const getNoHeader = document.getElementById('no-page-header');
let bool = false;

menuToggle.addEventListener('click', () => {
    bool = !bool; // to make button toggleable.
    if (bool) {
        for(let i = 0; i < menuToggle.children.length; i++) {
            menuToggle.children[i].classList.add('light-gray');
            menuToggle.children[i].classList.add('active');
        }
        if (logo) {
            for(let i = 0; i < logo.children.length; i++) {
                // filter to add correct color to svg.
                logo.children[i].style.filter = 'invert(48%) sepia(89%) saturate(3956%) hue-rotate(154deg) brightness(97%) contrast(101%)';
            }
        }
    } else {
        for(let i = 0; i < menuToggle.children.length; i++) {
            menuToggle.children[i].classList.remove('light-gray');
            menuToggle.children[i].classList.remove('active');
        }
        if (logo && !getNoHeader) {
            for(let i = 0; i < logo.children.length; i++) {
                // sets color to original.
                logo.children[i].style.filter = "";
            }
        }
    }
    showMenu(bool);
})

// Add sticky header.
const sticky = {
    sticky_after: 200,
    init: function() {
        this.header = document.getElementById('masthead');
        this.clone = this.header.cloneNode(true);
        this.clone.classList.add('clone');
        this.clone.id = 'masthead-clone'
        this.header.insertBefore(this.clone, null);
        this.scroll();
        this.events();
        this.hamburger();
        this.search();
    }, 
    scroll: function() {
        if (window.scrollY > this.sticky_after) {
            document.body.classList.add('down');
        } else {
            document.body.classList.remove('down');
        }
    },
    events: function() {
        window.addEventListener('scroll', this.scroll.bind(this));
    },
    hamburger: function() {
        const hamburger = document.querySelector('#masthead-clone > #menu-toggle');
        let newBool = false;
        hamburger.addEventListener('click', () => {
            newBool = !newBool; // to make button toggleable
            if (newBool) {
                for(let i = 0; i < hamburger.children.length; i++) {
                    hamburger.children[i].classList.add('active');
                }
                if (logo) {
                    for(let i = 0; i < logo.children.length; i++) {
                        // filter to add correct color to svg
                        logo.children[i].style.filter = 'invert(48%) sepia(89%) saturate(3956%) hue-rotate(154deg) brightness(97%) contrast(101%)';
                    }
                }
            } else {
                for(let i = 0; i < hamburger.children.length; i++) {
                    hamburger.children[i].classList.remove('active');
                }
                if (logo) {
                    for(let i = 0; i < logo.children.length; i++) {
                        // sets color to original
                        logo.children[i].style.filter = "";
                    }
                }
            }
            showMenu(newBool);
        })
    },
    search: function() {
        const searchToggle = document.querySelector('#masthead-clone .searchform-wrapper > #search-toggle');
        const searchForm = document.querySelector('#masthead-clone .searchform-wrapper > #searchform');
        let toggle = false;

        if (searchToggle) {
            searchToggle.addEventListener('click', (e) => {
                if (e.currentTarget === searchToggle) {
                    toggle = !toggle;
                }
                if (toggle) {
                    searchForm.classList.add('active');
                    searchToggle.classList.add('active');
                } else {
                    searchForm.classList.remove('active');
                    searchToggle.classList.remove('active');
                }
            })
        }
    }
};
document.addEventListener('DOMContentLoaded', sticky.init.bind(sticky));

// toggle sub sub menus.
const submenu = document.querySelectorAll('.sub-menu .menu-item');
submenu.forEach( menu => {
    menu.addEventListener('mouseover', (e) => {
        if (e.currentTarget === menu) {
            for (let i = 0; i < menu.children.length; i++) {
                document.querySelectorAll('.menu-item').forEach(bottom => {
                    bottom.classList.remove('sub-menu-active');
                })
                document.querySelectorAll('.sub-menu .bottom-menu-active').forEach (sub => {
                    sub.classList.remove('bottom-menu-active');
                })
                if (menu.children[i].classList.contains('sub-menu')) {
                    menu.children[i].classList.add('bottom-menu-active');
                }
                menu.classList.add('sub-menu-active');
            }
        }
    })
})

// fix bottom menu hrefs.
const bottomMenu = document.querySelectorAll('.menu .sub-menu .menu-item-has-children');
bottomMenu.forEach( item => {
    const childs = item.children;
    const newHref = item.children[0].href;
    for(let i = 0; i < childs.length; i++) {
        if(childs[i].classList.contains('sub-menu')) {
            const newChilds = childs[i].children;
            for(let i = 0; i < newChilds.length; i++) {
                const prevHref = `#${newChilds[i].children[0].innerHTML}`;
                newChilds[i].children[0].href = newHref + prevHref;
            }
        }
    }
})

// stop event propagation from parent element.
const subMenus = document.querySelectorAll('.sub-menu')
subMenus.forEach(menu => {
    menu.addEventListener('click', (e) => {
        e.stopPropagation();
    })
})

// page menu variables.
const pageMenuItem = document.getElementsByClassName('sc-page-menu-item');
const pageMenuSubItem = document.querySelectorAll('.page-menu-sub-items');
// get pagemenu item href.
const parentLink = document.getElementsByClassName('sc-page-menu-link');

// Set page menu open on current page.
for (let i = 0; i < pageMenuItem.length; i++){
    if (location.href.replace(location.hash, "") === parentLink[i].href) {
        parentLink[i].classList.add('active');
        pageMenuSubItem[i].style.display = 'block';
    }
}

// Options for intersection observer
let intersectionObserverOptions = {
    rootMargin: '-120px 0px -200px 0px',
    threshold: [0.10, 0.20, 0.30, 0.40, 0.50, 0.60, 0.70, 0.80, 0.90, 1],
}

// add scroll progress styling to page menu.
if (document.querySelector('.page-menu-sub-items')) {
    window.addEventListener('load', () => {
        const observer = new IntersectionObserver( entries => {
            entries.forEach( entry => {

                const id = entry.target.getAttribute('id');
                const setActive = document.querySelector(`a[id="${id}"]`);

                if (entry.isIntersecting && setActive) {
                        setActive.classList.add('active');
                } else {
                    setActive.classList.remove('active');
                }
            });
        }, intersectionObserverOptions);
        document.querySelectorAll('.child-page').forEach((item) => {
            observer.observe(item);
        })
    })
}

// Add event listener to latest news button on frontpage.
const latestButton = document.querySelector('.latest-news-button');
const target = document.getElementById('scroll-to-target');

if (latestButton) {
    latestButton.addEventListener('click', () => {
        const scrollPos = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: scrollPos - 120,
            behavior: 'smooth'
        })
    })
}

// Add ajax to load more button.
const loadMore = document.getElementById('load-more');
const loadMoreTargets = document.getElementById('load-more-target');
if (loadMore) {
    loadMore.addEventListener('click', () => {
        const url = load_more_posts.ajaxurl
        let data  = `action=load_more_posts&offset=${loadMoreTargets.children.length + 2}`;
        fetch(url,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept': 'application/json'
                    },
                    body: data
                }
            )
        .then(res => res.json())
        .then(res => {
            if(res.data.posts) {
                loadMoreTargets.innerHTML += res.data.posts;
                if (loadMoreTargets.children.length % 3 !== 0) {
                    loadMore.classList.add('hidden');
                }
            } else {
                loadMore.classList.add('hidden');
            }
        })
    })
}

//Add ajax to load more load more stocks
const loadMoreStocks = document.getElementById('load-more-stock');
const loadMoreStockTargets = document.getElementById('load-more-stocks-target');

if (loadMoreStocks) {
    loadMoreStocks.addEventListener('click', () => {
        const url = load_more_stocks.ajaxurl
        let data  = `action=load_more_stocks&offset=${loadMoreStockTargets.children.length}`;
        fetch(url,
                {
                    method: 'POST',
                    headers: { 
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept': 'application/json'
                    },
                    body: data
                }
            )
        .then(res => res.json())
        .then(res => {
            if(res.data.posts) {
                loadMoreStockTargets.innerHTML += res.data.posts;
                if (loadMoreStockTargets.children.length % 3 !== 0) {
                    loadMoreStocks.classList.add('hidden');
                }
            } else {
                loadMoreStocks.classList.add('hidden');
            }
        })
    })
}


// Search form toggle.
const searchToggle = document.getElementById('search-toggle');
const searchForm = document.getElementById('searchform');
let toggle = false;

if (searchToggle) {
    searchToggle.addEventListener('click', (e) => {
        if (e.currentTarget === searchToggle) {
            toggle = !toggle;
        }
        if (toggle) {
            searchForm.classList.add('active');
            searchToggle.classList.add('active');
        } else {
            searchForm.classList.remove('active');
            searchToggle.classList.remove('active');
        }
    })
}

// Check if video exists.
const video = document.getElementById('frontpage-video');
const heroText = document.querySelectorAll('.hero-text');

if (video) {
    heroText.forEach( text => {
        text.style.zIndex = '4';
    })
}

// Page is missing page header image.
const noHeader = document.getElementById('no-page-header');
const getHeader = document.getElementById('masthead');
if (noHeader)  {
    const hamburger = getHeader.children[0].querySelectorAll('.hamburger');
    const getLogo = getHeader.querySelectorAll('#logo');
    const searchForm = getHeader.querySelector('#searchform');

    // Change hamburger button color.
    hamburger.forEach( burger => {
        burger.classList.add('main-color');
    })
    // Change logo color.

    if (!getLogo[0].children[0].getAttribute('style')) {
        getLogo[0].children[0].style.filter = 'invert(48%) sepia(89%) saturate(3956%) hue-rotate(154deg) brightness(97%) contrast(101%)';
    }

    // Change search position and color.
    searchForm.querySelector('#search').style.border = '1px solid black';
    searchForm.querySelector('#searchsubmit').style.color = '#00a2a4';
    getHeader.querySelector('#search-toggle').style.filter = 'invert(48%) sepia(89%) saturate(3956%) hue-rotate(154deg) brightness(97%) contrast(101%)';

    // Change language switcher color.
    const allWpml = getHeader.querySelectorAll('.wpml-ls-link');
    allWpml.forEach( wpml => {
        wpml.style.color = '#00a2a4';
    })
}

// Disable footer on 404 page.
if (document.body.classList.contains('error404')) {
    const getFooter = document.getElementById('colophon');
    getFooter.style.display = 'none';
}

// Remove link from downloads header.
const downloads = document.querySelectorAll('.card-body');
downloads.forEach(download => {
    download.querySelector('h3.package-title a').removeAttribute('href');
});

// Contact header border

const getContactHeader = document.querySelector('.contact-page-content h2');

if (getContactHeader) {
    const seperator = document.createElement('span');
    seperator.classList.add('sc-contact-seperator');
    getContactHeader.insertAdjacentElement('afterend', seperator);
}

// Hover for to open text field frontpage.
const hoverElements = document.querySelectorAll('.box-container');
const shownElements = document.getElementsByClassName('tab-text');
if (hoverElements && shownElements) {
    hoverElements.forEach(elem => {
        elem.addEventListener('mouseover', e => {
            if (e.currentTarget.dataset.index) {
                for(let i = 0; i < shownElements.length; i++) {
                    if (shownElements[i].classList.contains('active')) {
                        shownElements[i].classList.remove('active');
                    }

                    if (shownElements[i].dataset.index === e.currentTarget.dataset.index) {
                        shownElements[i].classList.add('active');
                    }
                }
            }
        })
        elem.addEventListener('mouseout', e => {
            if (e.currentTarget.dataset.index) {
                for( let i = 0; i < shownElements.length; i++) {
                    if (shownElements[i].classList.contains('active')) {
                        shownElements[i].classList.remove('active');
                    }
                }
            }
        })
    })
}

//Render react boxes.
const boxesRoot = document.getElementById('boxes-root');
if ( boxesRoot ) {
    ReactDOM.render(<App />, boxesRoot);
}

// Create contact btn for psw pages
if (window.location.hostname === 'pswpower.no' || window.location.hostname === 'pswsolutions.no'  || window.location.hostname === 'localhost') {
	const contactBtn = document.createElement('a');

	contactBtn.href = `${window.location.origin}${window.location.pathname.includes('psw') ? '/scana/psw-power': ''}/contact`;
	contactBtn.classList.add('contact-btn');
	contactBtn.innerText = 'Contact Us!';
	contactBtn.id = 'contact-btn';
	document.body.insertAdjacentElement('beforeend', contactBtn);
}


// Create play/pause button for frontpage video
const vidEle = document.getElementById('frontpage-video');
const playBtn = document.getElementById('video-btn');

// Sometimes has error when movie hasnt been completely transferred to client cache;
// Evaluate whether pause on scroll is neccessary or not;
let distanceScrolled;
window.addEventListener('scroll', () => {
	distanceScrolled = window.scrollY;

	if (!vidEle) {
		return;
	}

	if (!vidEle.paused && distanceScrolled > 1080) {
		vidEle.pause();
	} else if (vidEle.paused && distanceScrolled < 1080) {
		try {
			vidEle.play();
		} catch (e) {
			console.log(e.message);
		}
	}
})